module.exports = __webpack_public_path__ + "img/2_35.5d8f64c5.png";